var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "word-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "word-icon-group2",
    transform: "translate(-92.000000, -387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "word-icon-group3",
    transform: "translate(92.000000, 387.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "word-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5405405,25.8498498 L28.5405405,7.01501502 C28.5405405,5.53513514 27.3297297,4.32432432 25.8498498,4.32432432 L7.01501502,4.32432432 C5.53513514,4.32432432 4.32432432,5.53513514 4.32432432,7.01501502 L4.32432432,25.8498498 C4.32432432,27.3297297 5.53513514,28.5405405 7.01501502,28.5405405 L25.8498498,28.5405405 C27.3297297,28.5405405 28.5405405,27.3297297 28.5405405,25.8498498 Z",
    id: "word-icon-path1",
    fill: "#0A79C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "word-icon-polyline1",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "25.2501878 11 21.6264834 22 18.6182965 22 16.5519754 15.6258825 14.3815533 22 11.3816284 22 8 11 11.0817185 11 13.0513745 18.1077813 15.4523058 11 17.7954033 11 20.0310951 18.1077813 22.1742527 11 25.2501878 11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/word-icon.22da43b5.svg";
export { ForwardRef as ReactComponent };